<template>
  <div class="menu-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong>{{ $t('clear_cache') }}</strong>
            </div>
            <b-col cols="6">
              <b-form-group v-bind:label="$t('obj_path')" :label-cols="3" :horizontal="true">
                <b-form-textarea class="form-control" v-model="item.obj_path" :rows="5" :max-rows="10" v-bind:placeholder="$t('obj_path_place_holder')"
                :state="!$v.item.obj_path.$invalid"
                  :aria-describedby="'obj_path-feedback'"/>
                  <b-form-invalid-feedback :id="'obj_path-feedback'">
                    {{ $t('required_filed') }}
                  </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <div slot="footer">
              <div class="text-center">
                <b-button variant="default" v-on:click="$router.go(-1)" ><i class="fa fa-arrow-left"></i>&nbsp; {{$t('back')}}</b-button>
                <b-button variant="success" v-on:click="clearCache()" :disabled="checkSubmit()" ><i class="fa fa-arrow-right"></i>&nbsp; {{$t('invalidate')}}</b-button>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import axios from 'axios'
const CancelToken = axios.CancelToken
let cancel = null
let vm = null

export default {
  name: 'ClearForm',
  props: {
    obj_path: {
      type: String
    }
  },
  components: {
  },
  data: function () {
    return {
      item: {
        obj_path: ""
      }
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    item: {
      obj_path: {
        required
      }
    }
  },
  methods: {
    checkSubmit: function(){
      return vm.$v.item.$invalid
    },
    clearCache() {
      let paths = []
      let object_paths = vm.item.obj_path.split("\n")
      for (let i = 0; i < object_paths.length; i++) {
        paths.push(object_paths[i])
      }
      vm.axios.tenant.clearCache(paths, {
          cancelToken: new CancelToken(function executor(c) {
            cancel = c;
          })
        },
        function(response){
          vm.item.obj_path = ''
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        }
      )
    }
  },
  created: function () {
    vm = this
  },
  mounted: function () {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/admin/aws/BaseForm.vue